export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "personalized_report_2025": "ವೈಯಕ್ತಿಕ ವರದಿ 2025",
    "comprehensive_life_blueprint": "ಸಮಗ್ರ ಜೀವನ ನಕ್ಷೆ",
    "personalized_report_2025_description": "2025ಕ್ಕಾಗಿ ನಿಮ್ಮ ಸಂಪೂರ್ಣ ವೈಯಕ್ತಿಕ ಜ್ಯೋತಿಷ್ಯ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ. ವೃತ್ತಿ, ಪ್ರೀತಿ, ಹಣಕಾಸು, ಆರೋಗ್ಯ, ಕುಟುಂಬ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆ ಸೇರಿದಂತೆ ಎಲ್ಲಾ ಜೀವನ ಕ್ಷೇತ್ರಗಳನ್ನು ಒಳಗೊಂಡ ಸಮಗ್ರ ಒಳನೋಟಗಳು ತಿಂಗಳ ಮತ್ತು ತಿಂಗಳ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳೊಂದಿಗೆ.",

    // Service Information
    "enter_details_for_personalized_analysis": "ವೈಯಕ್ತಿಕ ವಿಶ್ಲೇಷಣೆ 2025ಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_personalized_analysis_2025": "ಸಂಪೂರ್ಣ ವೈಯಕ್ತಿಕ ವಿಶ್ಲೇಷಣೆ 2025",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_personalized_analysis_note": "2025 ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ವೈಯಕ್ತಿಕ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ಸಂಪೂರ್ಣ ಜೀವನ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_personalized_analysis": "ನಿಮ್ಮ ಹೆಸರು ವೈಯಕ್ತಿಕ ಜ್ಯೋತಿಷ್ಯ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ಅನನ್ಯ ಕಂಪನಗಳನ್ನು ಸೃಷ್ಟಿಸುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_comprehensive_analysis": "ಸಮಗ್ರ ಜ್ಯೋತಿಷ್ಯ ಚಾರ್ಟ್ ಮತ್ತು 2025 ಭವಿಷ್ಯವಾಣಿಗಳಿಗೆ ಅಗತ್ಯವಾದುದು",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_comprehensive_analysis": "ನಿಖರವಾದ ಭವನ ಲೆಕ್ಕಾಚಾರಗಳು ಮತ್ತು ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_personalized_analysis": "ಸ್ಥಳವು ವೈಯಕ್ತಿಕ ಭವಿಷ್ಯವಾಣಿಗಳಿಗಾಗಿ ಗ್ರಹಗಳ ಸ್ಥಾನಗಳ ಮೇಲೆ ಪ್ರಭಾವ ಬೀರುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವರದಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core 2025 Features
    "comprehensive_life_analysis": "ಸಮಗ್ರ ಜೀವನ ವಿಶ್ಲೇಷಣೆ",
    "year_2025_predictions": "ವರ್ಷ 2025 ಭವಿಷ್ಯವಾಣಿಗಳು",
    "all_life_areas_analysis": "ಎಲ್ಲಾ ಜೀವನ ಕ್ಷೇತ್ರಗಳ ವಿಶ್ಲೇಷಣೆ",
    "personalized_remedies_solutions": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಪರಿಹಾರಗಳು",
    "monthly_guidance_2025": "ಮಾಸಿಕ ಮಾರ್ಗದರ್ಶನ 2025",
    "premium_pdf_report": "ಪ್ರೀಮಿಯಂ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವರದಿ 2025 ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "complete_life_blueprint": "ಸಂಪೂರ್ಣ ಜೀವನ ನಕ್ಷೆ",
    "year_2025_forecast": "ವರ್ಷ 2025 ಮುನ್ಸೂಚನೆ",
    "personalized_remedies": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳು",
    "monthly_predictions_guide": "ಮಾಸಿಕ ಭವಿಷ್ಯವಾಣಿಗಳ ಮಾರ್ಗದರ್ಶಿ",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ವೈಯಕ್ತಿಕ ವರದಿ 2025 ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "personalized_analysis_processing": "2025ಗಾಗಿ ನಿಮ್ಮ ಸಮಗ್ರ ವೈಯಕ್ತಿಕ ವರದಿಯನ್ನು ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ತಿಂಗಳ ಮತ್ತು ತಿಂಗಳ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ಎಲ್ಲಾ ಜೀವನ ಕ್ಷೇತ್ರಗಳನ್ನು ಒಳಗೊಂಡ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_48_hours_delivery_note": "ನಿಮ್ಮ ಸಮಗ್ರ ವೈಯಕ್ತಿಕ ವರದಿ 48 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವರದಿ 2025 ಪ್ಯಾಕೇಜ್",
    "comprehensive_personalized_report": "ಸಮಗ್ರ ವೈಯಕ್ತಿಕ ವರದಿ (PDF)",
    "complete_2025_predictions": "ಸಂಪೂರ್ಣ 2025 ಭವಿಷ್ಯವಾಣಿಗಳು",
    "all_life_areas_detailed_analysis": "ಎಲ್ಲಾ ಜೀವನ ಕ್ಷೇತ್ರಗಳ ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆ",
    "personalized_remedies_guide": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರಗಳ ಮಾರ್ಗದರ್ಶಿ",
    "monthly_action_plan_2025": "ಮಾಸಿಕ ಕಾರ್ಯ ಯೋಜನೆ 2025",

    // Visual Content
    "sample_personalized_analysis_2025": "ಮಾದರಿ ವೈಯಕ್ತಿಕ ವಿಶ್ಲೇಷಣೆ 2025",
    "year_2025_focus": "ವರ್ಷ 2025 ಗಮನ",
    "sample_2025_reading": "ಹಣಕಾಸಿನ ವಿಸ್ತರಣೆಯೊಂದಿಗೆ ವೃತ್ತಿ ಬೆಳವಣಿಗೆ ಮತ್ತು ಸಂಬಂಧದ ಸ್ಥಿರತೆ",
    "sample_2025_preview": "ಸಮಗ್ರ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ 2025 ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "year_2025_analysis_areas": "ವರ್ಷ 2025 ವಿಶ್ಲೇಷಣೆ ಕ್ಷೇತ್ರಗಳು",

    // 2025 Life Area Types
    "career_2025": "ವೃತ್ತಿ 2025",
    "love_2025": "ಪ್ರೀತಿ 2025",
    "finance_2025": "ಹಣಕಾಸು 2025",
    "health_2025": "ಆರೋಗ್ಯ 2025",
    "family_2025": "ಕುಟುಂಬ 2025",
    "spiritual_2025": "ಆಧ್ಯಾತ್ಮಿಕ 2025",

    // Status & Processing
    "your_personalized_analysis_status": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವಿಶ್ಲೇಷಣೆಯ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವರದಿ 2025 ರಚಿಸಲಾಗುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ತಜ್ಞ ಜ್ಯೋತಿಷಿಗಳು ವಿಸ್ತೃತ 2025 ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ತಿಂಗಳ ಮತ್ತು ತಿಂಗಳ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ಎಲ್ಲಾ ಜೀವನ ಕ್ಷೇತ್ರಗಳನ್ನು ಒಳಗೊಂಡ ನಿಮ್ಮ ಸಮಗ್ರ ವೈಯಕ್ತಿಕ ವರದಿಯನ್ನು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_48_hours": "48 ಗಂಟೆಗಳೊಳಗೆ ವರದಿ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಪ್ರೀಮಿಯಂ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // 2025 Year Overview
    "year_2025_overview": "ವರ್ಷ 2025 ಅವಲೋಕನ",
    "major_planetary_transits_2025": "ಪ್ರಮುಖ ಗ್ರಹ ಸಂಕ್ರಮಣಗಳು 2025",
    "key_astrological_events_2025": "ಪ್ರಮುಖ ಜ್ಯೋತಿಷ್ಯ ಘಟನೆಗಳು 2025",
    "annual_theme_2025": "ವಾರ್ಷಿಕ ವಿಷಯ 2025",
    "yearly_opportunities": "ವಾರ್ಷಿಕ ಅವಕಾಶಗಳು",
    "yearly_challenges": "ವಾರ್ಷಿಕ ಸವಾಲುಗಳು",

    // Monthly Analysis 2025
    "january_2025": "ಜನವರಿ 2025",
    "february_2025": "ಫೆಬ್ರವರಿ 2025",
    "march_2025": "ಮಾರ್ಚ್ 2025",
    "april_2025": "ಏಪ್ರಿಲ್ 2025",
    "may_2025": "ಮೇ 2025",
    "june_2025": "ಜೂನ್ 2025",
    "july_2025": "ಜುಲೈ 2025",
    "august_2025": "ಆಗಸ್ಟ್ 2025",
    "september_2025": "ಸೆಪ್ಟೆಂಬರ್ 2025",
    "october_2025": "ಅಕ್ಟೋಬರ್ 2025",
    "november_2025": "ನವೆಂಬರ್ 2025",
    "december_2025": "ಡಿಸೆಂಬರ್ 2025",

    // Career 2025
    "career_forecast_2025": "ವೃತ್ತಿ ಮುನ್ಸೂಚನೆ 2025",
    "professional_growth_2025": "ವೃತ್ತಿಪರ ಬೆಳವಣಿಗೆಯ ಅವಕಾಶಗಳು",
    "job_changes_2025": "ಕೆಲಸ ಬದಲಾವಣೆಗಳು ಮತ್ತು ಪರಿವರ್ತನೆಗಳು",
    "business_prospects_2025": "ವ್ಯಾಪಾರ ಭವಿಷ್ಯ 2025",
    "leadership_opportunities_2025": "ನಾಯಕತ್ವದ ಅವಕಾಶಗಳು",
    "salary_increment_timing": "ಸಂಬಳ ಹೆಚ್ಚಳದ ಸಮಯ",
    "career_challenges_2025": "ನ್ಯಾವಿಗೇಟ್ ಮಾಡಲು ವೃತ್ತಿ ಸವಾಲುಗಳು",

    // Finance 2025
    "financial_forecast_2025": "ಹಣಕಾಸು ಮುನ್ಸೂಚನೆ 2025",
    "income_growth_2025": "ಆದಾಯ ಬೆಳವಣಿಗೆಯ ಸಾಮರ್ಥ್ಯ",
    "investment_opportunities": "ಹೂಡಿಕೆ ಅವಕಾಶಗಳು",
    "expenditure_patterns": "ಖರ್ಚಿನ ಮಾದರಿಗಳು",
    "wealth_accumulation": "ಸಂಪತ್ತು ಸಂಗ್ರಹಣೆಯ ಟೈಮ್‌ಲೈನ್",
    "financial_challenges": "ಹಣಕಾಸಿನ ಸವಾಲುಗಳು",
    "money_management_tips": "ಹಣ ನಿರ್ವಹಣೆ ಸಲಹೆಗಳು",

    // Love & Relationships 2025
    "love_forecast_2025": "ಪ್ರೀತಿ ಮುನ್ಸೂಚನೆ 2025",
    "relationship_developments": "ಸಂಬಂಧದ ಬೆಳವಣಿಗೆಗಳು",
    "marriage_prospects_2025": "ವಿವಾಹದ ಭವಿಷ್ಯ 2025",
    "family_harmony": "ಕುಟುಂಬ ಸಾಮರಸ್ಯದ ಮುನ್ಸೂಚನೆ",
    "romantic_opportunities": "ಪ್ರಣಯ ಅವಕಾಶಗಳು",
    "relationship_challenges": "ಸಂಬಂಧದ ಸವಾಲುಗಳು",
    "love_life_enhancement": "ಪ್ರೀತಿಯ ಜೀವನ ವರ್ಧನೆ",

    // Health 2025
    "health_forecast_2025": "ಆರೋಗ್ಯ ಮುನ್ಸೂಚನೆ 2025",
    "vitality_levels": "2025 ಉದ್ದಕ್ಕೂ ಚೈತನ್ಯ ಮಟ್ಟಗಳು",
    "health_vulnerable_periods": "ಆರೋಗ್ಯ ದುರ್ಬಲ ಅವಧಿಗಳು",
    "wellness_recommendations": "ಆರೋಗ್ಯ ಶಿಫಾರಸುಗಳು",
    "fitness_goals_2025": "ಫಿಟ್‌ನೆಸ್ ಗುರಿಗಳು 2025",
    "mental_health_focus": "ಮಾನಸಿಕ ಆರೋಗ್ಯ ಗಮನ ಕ್ಷೇತ್ರಗಳು",
    "preventive_care_guidance": "ತಡೆಗಟ್ಟುವ ಆರೈಕೆ ಮಾರ್ಗದರ್ಶನ",

    // Spiritual Growth 2025
    "spiritual_journey_2025": "ಆಧ್ಯಾತ್ಮಿಕ ಪ್ರಯಾಣ 2025",
    "meditation_practices": "ಶಿಫಾರಸು ಮಾಡಿದ ಧ್ಯಾನ ಅಭ್ಯಾಸಗಳು",
    "spiritual_awakening": "ಆಧ್ಯಾತ್ಮಿಕ ಜಾಗೃತಿ ಅವಕಾಶಗಳು",
    "inner_growth_phases": "ಆಂತರಿಕ ಬೆಳವಣಿಗೆಯ ಹಂತಗಳು",
    "divine_connections": "ದೈವಿಕ ಸಂಪರ್ಕಗಳು",
    "karmic_lessons_2025": "ಕಾರ್ಮಿಕ ಪಾಠಗಳು 2025",

    // Personalized Remedies
    "customized_remedies": "2025ಗಾಗಿ ಕಸ್ಟಮೈಸ್ ಪರಿಹಾರಗಳು",
    "gemstone_recommendations": "ರತ್ನ ಶಿಫಾರಸುಗಳು",
    "mantra_suggestions": "ಮಂತ್ರ ಸಲಹೆಗಳು",
    "ritual_guidance": "ಆಚರಣೆಯ ಮಾರ್ಗದರ್ಶನ",
    "charitable_activities": "ಪ್ರಯೋಜನಕಾರಿ ದತ್ತಿ ಚಟುವಟಿಕೆಗಳು",
    "lifestyle_modifications": "ಜೀವನಶೈಲಿ ಮಾರ್ಪಾಡುಗಳು",
    "lucky_colors_2025": "2025ಗಾಗಿ ಅದೃಷ್ಟದ ಬಣ್ಣಗಳು",
    "auspicious_dates": "ಶುಭ ದಿನಾಂಕಗಳು ಮತ್ತು ಸಮಯ",

    // Timing & Cycles
    "auspicious_periods_2025": "ಶುಭ ಅವಧಿಗಳು 2025",
    "challenging_periods": "ನ್ಯಾವಿಗೇಟ್ ಮಾಡಲು ಸವಾಲಿನ ಅವಧಿಗಳು",
    "optimal_decision_timing": "ಸೂಕ್ತ ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವ ಸಮಯಗಳು",
    "new_venture_timing": "ಹೊಸ ಉದ್ಯಮ ಪ್ರಾರಂಭದ ಸಮಯ",
    "travel_recommendations": "ಪ್ರಯಾಣ ಶಿಫಾರಸುಗಳು",
    "important_date_alerts": "ಪ್ರಮುಖ ದಿನಾಂಕ ಅಲರ್ಟ್‌ಗಳು",

    // Personal Development 2025
    "skill_development_2025": "ಕೌಶಲ್ಯ ಅಭಿವೃದ್ಧಿ ಗಮನ 2025",
    "learning_opportunities": "ಕಲಿಕೆಯ ಅವಕಾಶಗಳು",
    "personal_growth_areas": "ವೈಯಕ್ತಿಕ ಬೆಳವಣಿಗೆಯ ಕ್ಷೇತ್ರಗಳು",
    "character_development": "ಪಾತ್ರ ಅಭಿವೃದ್ಧಿ ಗಮನ",
    "habit_formation": "ಪ್ರಯೋಜನಕಾರಿ ಅಭ್ಯಾಸ ರಚನೆ",
    "goal_achievement_strategy": "ಗುರಿ ಸಾಧನೆ ತಂತ್ರ",

    // Social & Networking 2025
    "social_connections_2025": "ಸಾಮಾಜಿಕ ಸಂಪರ್ಕಗಳು 2025",
    "networking_opportunities": "ನೆಟ್‌ವರ್ಕಿಂಗ್ ಅವಕಾಶಗಳು",
    "friendship_developments": "ಸ್ನೇಹದ ಬೆಳವಣಿಗೆಗಳು",
    "community_involvement": "ಸಮುದಾಯ ಒಳಗೊಳ್ಳುವಿಕೆ",
    "social_influence_growth": "ಸಾಮಾಜಿಕ ಪ್ರಭಾವದ ಬೆಳವಣಿಗೆ",

    // Technology & Innovation 2025
    "technology_adoption": "ತಂತ್ರಜ್ಞಾನ ಅಳವಡಿಕೆ ಮಾರ್ಗದರ್ಶನ",
    "digital_opportunities": "ಡಿಜಿಟಲ್ ಅವಕಾಶಗಳು",
    "innovation_potential": "ನಾವೀನ್ಯತೆಯ ಸಾಮರ್ಥ್ಯ",
    "online_presence": "ಆನ್‌ಲೈನ್ ಉಪಸ್ಥಿತಿ ವರ್ಧನೆ",
    "digital_financial_growth": "ಡಿಜಿಟಲ್ ಹಣಕಾಸಿನ ಬೆಳವಣಿಗೆ",

    // Travel & Relocation 2025
    "travel_forecast_2025": "ಪ್ರಯಾಣ ಮುನ್ಸೂಚನೆ 2025",
    "relocation_possibilities": "ಸ್ಥಳಾಂತರ ಸಾಧ್ಯತೆಗಳು",
    "foreign_opportunities": "ವಿದೇಶಿ ಅವಕಾಶಗಳು",
    "pilgrimage_recommendations": "ಯಾತ್ರೆಯ ಶಿಫಾರಸುಗಳು",
    "educational_travel": "ಶೈಕ್ಷಣಿಕ ಪ್ರಯಾಣ",

    // Legal & Official Matters 2025
    "legal_matters_guidance": "ಕಾನೂನು ವಿಷಯಗಳ ಮಾರ್ಗದರ್ಶನ",
    "official_work_timing": "ಅಧಿಕೃತ ಕೆಲಸದ ಸಮಯ",
    "documentation_periods": "ಅನುಕೂಲಕರ ದಾಖಲೀಕರಣ ಅವಧಿಗಳು",
    "government_dealings": "ಸರ್ಕಾರಿ ವ್ಯವಹಾರಗಳು",
    "property_matters": "ಆಸ್ತಿ ಸಂಬಂಧಿತ ವಿಷಯಗಳು",

    // Creative & Artistic 2025
    "creative_expression_2025": "ಸೃಜನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ 2025",
    "artistic_pursuits": "ಕಲಾತ್ಮಕ ಅನುಸರಣೆಗಳು",
    "creative_projects": "ಸೃಜನಾತ್ಮಕ ಯೋಜನೆಗಳ ಸಮಯ",
    "artistic_collaborations": "ಕಲಾತ್ಮಕ ಸಹಯೋಗಗಳು",
    "creative_income_potential": "ಸೃಜನಾತ್ಮಕ ಆದಾಯದ ಸಾಮರ್ಥ್ಯ",

    // Education & Knowledge 2025
    "educational_pursuits": "ಶೈಕ್ಷಣಿಕ ಅನುಸರಣೆಗಳು 2025",
    "skill_certifications": "ಕೌಶಲ್ಯ ಪ್ರಮಾಣಪತ್ರಗಳು",
    "knowledge_expansion": "ಜ್ಞಾನ ವಿಸ್ತರಣೆ ಕ್ಷೇತ್ರಗಳು",
    "research_projects": "ಸಂಶೋಧನಾ ಯೋಜನೆಗಳು",
    "teaching_opportunities": "ಬೋಧನೆಯ ಅವಕಾಶಗಳು",

    // Environmental & Lifestyle 2025
    "living_environment": "ವಾಸದ ಪರಿಸರ ಬದಲಾವಣೆಗಳು",
    "lifestyle_upgrades": "ಜೀವನಶೈಲಿ ಅಪ್‌ಗ್ರೇಡ್‌ಗಳು",
    "home_improvements": "ಮನೆ ಸುಧಾರಣೆಗಳ ಸಮಯ",
    "environmental_consciousness": "ಪರಿಸರ ಜಾಗೃತಿ",
    "sustainable_living": "ಸುಸ್ಥಿರ ಜೀವನ ಅಭ್ಯಾಸಗಳು"
};
